import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import MyULogo from '@/shared/ui/MyULogo';

const links = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
];

export default function Navbar() {
  return (
    <header className="border-b bg-white shadow-sm">
      <nav className="container mx-auto flex items-center justify-between px-4 py-3">
        <MyULogo variant="full" size="lg" href="/" />
        <ul className="flex gap-4">
          {links.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                end
                className={({ isActive }) =>
                  clsx(
                    'rounded px-3 py-1.5 text-sm font-medium transition',
                    isActive ? 'bg-primary-600 text-white' : 'text-gray-700 hover:bg-gray-100',
                  )
                }
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
